import type { ModuleManifest } from '@eis/core';
import { partnersPermissions as p } from './permissions';
import { partnersResources } from './i18n';

/**
 * The partners module's single manifest — its one integration point with the shell (backbone §2).
 *
 * The Partner domain is another team's service (SDD-014 PS-1); this module is the console's view
 * of it: an overview, a details page, the create/edit/tag dialogs, and the picker the insurance
 * dialogs open. It owns the `partner-management` catalog (§8) and nothing of the insurance
 * module's — the two talk through typed link builders in `@eis/core` only (backbone §1).
 *
 * `nav` carries the SAME permission declaration the routes are guarded with, so the menu and the
 * guard cannot drift apart (Addendum A.2). One heading of its own: partners are neither
 * configuration nor an instance of it — they are the parties both operating personas name.
 */
export const partnersModule: ModuleManifest = {
  id: 'partners',
  basePath: '/partners',
  routes: () => import('./routes'),
  nav: [
    {
      label: 'partners:nav.partners',
      icon: 'feather:users',
      to: '/partners/all',
      section: 'partners:nav.sections.partners',
      permissions: [[p.partners.view]],
    },
  ],
  i18nNamespaces: ['partners'],
  permissionCatalog: p,
  featureFlagPrefix: 'partners.',
  i18nResources: partnersResources,
};
